import { useEffect, useState } from "react";
import usePreprocessors from "../components/ContentBlock/preProcessors";

const noop = () => null;

// This hook is used in multiple places
// If you're adding parameters here, make sure to pass them from
// both <ContentBlock /> and <FindInTopic />
// See https://ebscoinddev.atlassian.net/wiki/spaces/ART/pages/115509624/F64796+MFE+Find+in+Topic#Parsing-and-pre-processing-loaded-sections

const useContentPreprocessors = ({
  updates,
  hfcData,
  tablesContent,
  transformData,
  multimedia,
  referenceData,
  referenceSectionId,
  userExperience,
  ancillaryData,
  isMobileDevice,
  isTabletDevice,
  loe,
  slugPubType,
  slugTitle,
  telemetryData,
  handleOpenPDF = noop,
  handleOpenLightBoxImage = noop,
  handleOpenLightBoxVideo = noop,
  handlePercLinkNavigation = noop,
  handleHFCDialogOpen = noop,
  setIsDialogOpen = noop,
  setTableData = noop,
  setIsEvidenceBottomSheetOpen = noop,
  openFtfDialog = noop,
  openBottomSheet = noop,
}) => {
  const { videos = [], images = [], algorithms = [] } = multimedia || {};
  const { processContentPage, modalAssets } = usePreprocessors({
    handleOpenPDF,
    handleOpenLightBoxImage,
    handleOpenLightBoxVideo,
    handlePercLinkNavigation,
    handleHFCDialogOpen,
    transformData,
    videos,
    images,
    algorithms,
    tablesContent,
    referenceData,
    openFtfDialog,
    openBottomSheet,
    userExperience,
    setIsDialogOpen,
    setTableData,
    ancillaryData,
    referenceSectionId,
    setIsEvidenceBottomSheetOpen,
    updates,
    hfcData,
    isMobileDevice,
    isTabletDevice,
    loe,
    slugPubType,
    slugTitle,
    telemetryData,
  });

  const [preProcessorInstance, setPreProcessorInstance] = useState();
  useEffect(() => {
    const preProcessors = [processContentPage()];
    if (!preProcessorInstance) {
      setPreProcessorInstance(preProcessors);
    }
  }, [preProcessorInstance, processContentPage]);

  return {
    processContentPage,
    modalAssets,
    preProcessorInstance,
  };
};

export default useContentPreprocessors;
